module.exports = __webpack_public_path__ + "4af62a88be0d315f545696067cac608d.svg";